import { render } from "./ClientInstall.vue?vue&type=template&id=5539b01c"
import script from "./ClientInstall.vue?vue&type=script&lang=js"
export * from "./ClientInstall.vue?vue&type=script&lang=js"

import "./ClientInstall.vue?vue&type=style&index=0&id=5539b01c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__